import {getSingleInputElementByNameV3} from "../../../helpers/forms/formInputsHelpers";
import {loading} from "../../../helpers/loading";

function initProductionAllConflictsIndex() {
	// Init filter type select
	const filterSelect = getSingleInputElementByNameV3(document.body, 'view_type');

	if (filterSelect) {
		filterSelect.addEventListener('change', () => {
			handleFilterChange();
		})
	}

	// Methods
	function handleFilterChange() {
		const urlParams = new URLSearchParams(location.search);
		urlParams.set('filter', filterSelect.value);
		loading();
		window.location.search = urlParams.toString();
	}
}

export {
	initProductionAllConflictsIndex
}
